// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pQhs","productName":"Table_productName__35iLd"};